/* eslint-disable react/prop-types */
/* eslint-disable no-console */
import React, { Component } from 'react';
import './paymentSuccessPage.scss';
import { windowOpenHandler } from '../../../utility/common';
import { withRouter } from 'react-router-dom';
import { userAgent } from '../../../api/api-config';
import PaymentSuccess from '../../../asset/images/payment_success.svg';
import paymentFailed from '../../../asset/images/paymentFailed.svg';
import DesigningHouse from '../../../asset/images/designing_house.svg';
import { withTranslation } from 'react-i18next';
//import Loader from '../../shared-ui/Loader';

class PaymentSuccessPage extends Component {

  constructor (props) {
    super(props);
    this.gotoHomeDetails = this.gotoHomeDetails.bind(this);
    this.viewDesignDoc = this.viewDesignDoc.bind(this);
    this.state = {
      isLoading: false,
      paymentStatus : window.location.toString().includes('payment-confirmation') ? 'failed' : 'success',
      ProcessingPage : localStorage.getItem('orderId') ? false : true
    };
  }


  gotoHomeDetails () {
    // eslint-disable-next-line react/prop-types
    // eslint-disable-next-line react/prop-types
    const { history } = this.props;
    const houseId = localStorage.getItem('houseId');
    if(this.state.paymentStatus === 'success') {
      this.props.continueDoc && this.props.continueDoc();
    } else {
      history.push(`/home-details?house-id=${houseId}`);
    }
  }

  viewDesignDoc () {
    const houseId = localStorage.getItem('houseId');
    const shareToken = localStorage.getItem('shareToken');
    const langCode = localStorage.getItem('lang');
    windowOpenHandler(`/design-document?house_id=${houseId}&share_token=${shareToken}&preferred_language=${langCode}&user_agent=${userAgent}`);
    if (typeof this.props.continueDoc === 'function') {
      this.props.continueDoc();
    }
  }

  render () {
    // eslint-disable-next-line react/prop-types
    const DesignDocPrice = localStorage.getItem('DesignDocPrice') || 999 ;
    //const { isLoading } = this.state;
    const { t } = this.props;

    return (
      <div>
        {/* <Loader
          isLoading={isLoading} /> */}
        {!this.state.ProcessingPage ?
          <div className='payment_container'>
            <div className='close_icon_wrapper'>
              <div className='close_icon'
                onClick={this.gotoHomeDetails} />
            </div>
            {this.state.paymentStatus === 'success' ?
              <div className='image'>
                <img src={PaymentSuccess} />
              </div> :
              <div className='image'>
                <img src={paymentFailed} />
              </div> }
            {this.state.paymentStatus === 'success' ?
              <div className='description'>
                {t('successful_payment_desc')} <span> ₹{DesignDocPrice.toLocaleString('en-IN')} </span> {t('successful_payment_desc_second')}
              </div> :
              <div className='description'>
                {t('successful_payment_desc')} <span> ₹{DesignDocPrice.toLocaleString('en-IN')} </span> {t('unsuccessful_payment_desc_second')}
              </div>}
            {this.state.paymentStatus === 'success' ?
              <div className='button'
                onClick={this.viewDesignDoc} >{t('view_design_doc')}
              </div> :
              <div className='button'
                onClick={this.gotoHomeDetails} >{t('retry')}
              </div> }
          </div> :
          <div className='payment_processing_container'>
            <div className='image'>
              <img src={DesigningHouse} />
            </div>
            <div className='description'>
              <div>{t('design_your_house')}</div>
              <div>{t('loading_time')}</div>
            </div>
          </div>
        }
      </div>

    // Use following component for designing house screen 4.6 ********************
    // <div className='payment_processing_container'>
    //   <div className='image'>
    //     <img src={DesigningHouse} />
    //   </div>
    //   <div className='description'>
    //     <div>DESIGNING YOUR HOUSE</div>
    //     <div>THIS MAY TAKE A FEW SECONDS</div>
    //   </div>
    // </div>
    );
  }
}

export default withTranslation()(withRouter(PaymentSuccessPage));